/**
 * Loại dự toán chi
 */
export default {
  BuPlanExpenseBudget: 150, // 'Dự toán chi đầu năm theo MLNS',
  BuPlanExpenseBudgetAdd: 151, // 'Dự toán chi bổ sung theo MLNS',
  BuPlanExpenseBudgetSupplement: 320, // 'Điều chỉnh dự toán chi theo MLNS',
  BuPlanExpenseActivity: 990, // 'Dự toán chi đầu năm theo NDKT',
  BuPlanExpenseActivitySupplement: 991, // 'Dự toán chi bổ sung theo NDKT',
  BuPlanExpenseActivityAdjust: 992, // 'Điều chỉnh dự toán chi theo NDKT'
};
